/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Document } from '../models';
// @ts-ignore
import type { DocumentSlot } from '../models';
// @ts-ignore
import type { DocumentStatus } from '../models';
// @ts-ignore
import type { InputReviewDocument } from '../models';
/**
 * AdminServiceRequestDocumentApi - axios parameter creator
 * @export
 */
export const AdminServiceRequestDocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a document from archive with matching queries
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentForServiceRequestId: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('getDocumentForServiceRequestId', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/admin/document/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (serviceRequestId !== undefined) {
                localVarQueryParameter['serviceRequestId'] = serviceRequestId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all document slots for admin by request id
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSlotsForAdminByRequestId: async (serviceId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceId' is not null or undefined
            assertParamExists('getDocumentSlotsForAdminByRequestId', 'serviceId', serviceId)
            const localVarPath = `/admin/document/byServiceRequest/{serviceId}`
                .replace(`{${"serviceId"}}`, encodeURIComponent(String(serviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary review a document uploaded by a user
         * @param {InputReviewDocument} [inputReviewDocument] body for reviewing a document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewDocument: async (inputReviewDocument?: InputReviewDocument, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/document/caf-review`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputReviewDocument, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminServiceRequestDocumentApi - functional programming interface
 * @export
 */
export const AdminServiceRequestDocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminServiceRequestDocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a document from archive with matching queries
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Document>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentForServiceRequestId(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestDocumentApi.getDocumentForServiceRequestId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all document slots for admin by request id
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentSlotsForAdminByRequestId(serviceId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentSlot>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentSlotsForAdminByRequestId(serviceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestDocumentApi.getDocumentSlotsForAdminByRequestId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary review a document uploaded by a user
         * @param {InputReviewDocument} [inputReviewDocument] body for reviewing a document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reviewDocument(inputReviewDocument?: InputReviewDocument, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reviewDocument(inputReviewDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminServiceRequestDocumentApi.reviewDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminServiceRequestDocumentApi - factory interface
 * @export
 */
export const AdminServiceRequestDocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminServiceRequestDocumentApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a document from archive with matching queries
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Document>> {
            return localVarFp.getDocumentForServiceRequestId(serviceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all document slots for admin by request id
         * @param {number} serviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentSlotsForAdminByRequestId(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentSlot>> {
            return localVarFp.getDocumentSlotsForAdminByRequestId(serviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary review a document uploaded by a user
         * @param {InputReviewDocument} [inputReviewDocument] body for reviewing a document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reviewDocument(inputReviewDocument?: InputReviewDocument, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStatus> {
            return localVarFp.reviewDocument(inputReviewDocument, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminServiceRequestDocumentApi - interface
 * @export
 * @interface AdminServiceRequestDocumentApi
 */
export interface AdminServiceRequestDocumentApiInterface {
    /**
     * 
     * @summary Get a document from archive with matching queries
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestDocumentApiInterface
     */
    getDocumentForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Document>>;

    /**
     * 
     * @summary Get all document slots for admin by request id
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestDocumentApiInterface
     */
    getDocumentSlotsForAdminByRequestId(serviceId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentSlot>>;

    /**
     * 
     * @summary review a document uploaded by a user
     * @param {InputReviewDocument} [inputReviewDocument] body for reviewing a document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestDocumentApiInterface
     */
    reviewDocument(inputReviewDocument?: InputReviewDocument, options?: RawAxiosRequestConfig): AxiosPromise<DocumentStatus>;

}

/**
 * AdminServiceRequestDocumentApi - object-oriented interface
 * @export
 * @class AdminServiceRequestDocumentApi
 * @extends {BaseAPI}
 */
export class AdminServiceRequestDocumentApi extends BaseAPI implements AdminServiceRequestDocumentApiInterface {
    /**
     * 
     * @summary Get a document from archive with matching queries
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestDocumentApi
     */
    public getDocumentForServiceRequestId(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestDocumentApiFp(this.configuration).getDocumentForServiceRequestId(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all document slots for admin by request id
     * @param {number} serviceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestDocumentApi
     */
    public getDocumentSlotsForAdminByRequestId(serviceId: number, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestDocumentApiFp(this.configuration).getDocumentSlotsForAdminByRequestId(serviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary review a document uploaded by a user
     * @param {InputReviewDocument} [inputReviewDocument] body for reviewing a document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminServiceRequestDocumentApi
     */
    public reviewDocument(inputReviewDocument?: InputReviewDocument, options?: RawAxiosRequestConfig) {
        return AdminServiceRequestDocumentApiFp(this.configuration).reviewDocument(inputReviewDocument, options).then((request) => request(this.axios, this.basePath));
    }
}

